import { useSelector } from 'react-redux'
import { selectIsThanxAdmin } from 'selectors/thanxAdmin'

export default function useIsThanxAdmin() {
  return useSelector(selectIsThanxAdmin)
}
